import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Import komponen Home
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Product from "./components/Product";
import Clients from "./components/Clients";
import Contact from "./components/Contact";

// Import halaman penuh (All Pages)
import AboutALL from "./pages/AboutALL";
import ServiceALL from "./pages/ServiceALL";
import ProductALL from "./pages/ProductALL";
import ContactALL from "./pages/ContactALL";

const Home = () => (
  <>
    <Hero />
    <About />
    <Services />
    <Product />
    <Clients />
    <Contact />
  </>
);

// ✅ Ganti nama agar tidak bentrok
const AboutPage = () => (
  <>
    <AboutALL />
  </>
);

const ServicePage = () => (
  <>
    <ServiceALL />
  </>
);

const ProductPage = () => (
  <>
    <ProductALL />
  </>
);

const ContactPage = () => (
  <>
    <ContactALL />
  </>
);

const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />           {/* HOME */}
        <Route path="/about" element={<AboutPage />} /> {/* ABOUT ALL */}
        <Route path="/service" element={<ServicePage />} /> {/* SERVICE ALL */}
        <Route path="/product" element={<ProductPage />} /> {/* PRODUCT ALL */}
        <Route path="/contact" element={<ContactPage />} /> {/* CONTACT ALL */}
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
